import { Colors } from '@revenuemarket/design';

import { IconProps } from '../../types/icon';
import { Svg } from '../style';

export default function Export({
  width = 20,
  height = 20,
  fill = Colors.gray700,
  ...props
}: IconProps) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.75117 16.6667C4.35496 16.6667 4.0196 16.5295 3.74509 16.2549C3.47058 15.9804 3.33333 15.6451 3.33333 15.2489V4.75122C3.33333 4.35501 3.47058 4.01965 3.74509 3.74514C4.0196 3.47063 4.35496 3.33337 4.75117 3.33337H9.10999C9.27692 3.33337 9.41673 3.38971 9.52941 3.50239C9.64196 3.61494 9.69823 3.75468 9.69823 3.92161C9.69823 4.08854 9.64196 4.22828 9.52941 4.34083C9.41673 4.4535 9.27692 4.50984 9.10999 4.50984H4.75117C4.69078 4.50984 4.63549 4.53501 4.58529 4.58533C4.53496 4.63553 4.5098 4.69082 4.5098 4.75122V15.2489C4.5098 15.3093 4.53496 15.3646 4.58529 15.4147C4.63549 15.4651 4.69078 15.4902 4.75117 15.4902H15.2488C15.3092 15.4902 15.3645 15.4651 15.4147 15.4147C15.465 15.3646 15.4902 15.3093 15.4902 15.2489V10.89C15.4902 10.7231 15.5465 10.5833 15.6592 10.4706C15.7718 10.3581 15.9115 10.3018 16.0784 10.3018C16.2454 10.3018 16.3851 10.3581 16.4976 10.4706C16.6103 10.5833 16.6667 10.7231 16.6667 10.89V15.2489C16.6667 15.6451 16.5294 15.9804 16.2549 16.2549C15.9804 16.5295 15.645 16.6667 15.2488 16.6667H4.75117ZM15.4902 5.33632L8.6245 12.2022C8.51588 12.3107 8.37934 12.3662 8.2149 12.3689C8.05058 12.3713 7.91156 12.3158 7.79784 12.2022C7.68424 12.0885 7.62745 11.9507 7.62745 11.7889C7.62745 11.627 7.68424 11.4893 7.79784 11.3755L14.6637 4.50984H12.1569C11.9899 4.50984 11.8502 4.4535 11.7376 4.34083C11.625 4.22828 11.5686 4.08854 11.5686 3.92161C11.5686 3.75468 11.625 3.61494 11.7376 3.50239C11.8502 3.38971 11.9899 3.33337 12.1569 3.33337H15.9576C16.1599 3.33337 16.3286 3.40102 16.4637 3.53631C16.599 3.67148 16.6667 3.84017 16.6667 4.04239V7.84318C16.6667 8.01011 16.6103 8.14984 16.4976 8.26239C16.3851 8.37507 16.2454 8.43141 16.0784 8.43141C15.9115 8.43141 15.7718 8.37507 15.6592 8.26239C15.5465 8.14984 15.4902 8.01011 15.4902 7.84318V5.33632Z"
        fill={fill}
      />
    </Svg>
  );
}
